<template>
	<div class="wrapper">
		<TheVisitorTopbar />
		<main class="main">
			<slot />
		</main>
		<TheFooter />
		<div class="wrapper-shape">
			<img src="@/assets/shape.png">
		</div>
	</div>
</template>

<script>
import TheVisitorTopbar from '@/components/TheVisitorTopbar.vue';
import TheFooter from '@/components/TheFooter.vue';

export default {
	name: 'Visitor',

	components: {
		TheFooter,
		TheVisitorTopbar,
	},
};
</script>

<style lang="scss" scoped>
.wrapper {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	background-color: $color-accent-100;

	.main {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		position: relative;
		z-index: 1;
	}
}

.wrapper-shape {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: flex-end;
	z-index: 0;
	pointer-events: none;

	img {
		position: relative;
		width: 100%;
	}
}
</style>
